import { defineMessages } from "react-intl";

const messages = defineMessages({
    title: {
        id: "reportPlan.title",
    },
    description: {
        id: "reportPlan.description",
    },
    submit: {
        id: "general.send",
    },
    cancel: {
        id: "general.cancel",
    },
    close: {
        id: "general.close",
    },
    success: {
        id: "reportPlan.success",
    },
});

export default messages;
